import React from "react"
import styles from "./blockTextBlackImg.module.css"

const BlockTextBlackImg = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data
  return (
    <section className={styles.blockTextBlackImg}>
      <div className={styles.blockTextBlackImg__bgOrange} />
      <div className={styles.blockTextBlackImg__titleText}>
        <h3>{title}</h3>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
      <div className={styles.blockTextBlackImg__img}>
        <img src={`https://drupal.smartempo.com${image}`} alt={title} />
      </div>
    </section>
  )
}
export default BlockTextBlackImg
